/*
 * Copyright (c) Schrocken Inc.
 * Author: Ravi Teja
 * File Description: Main App file for Routes and Redux-Store
 */

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { serverError } from './containers/actions/errorActions';
import { userLogout } from './containers/actions/userActions';

import axios from 'axios';

import { setAuthToken } from './utils/setAuthToken';

// Main Routes file
import Routes from './Routes';

//Google Analytics
import { initiliseGoogleAnalytics } from './tracking/index';
import { pageView } from './tracking/index';

// Check for token
if (localStorage.authToken) {
  setAuthToken(localStorage.authToken);
}

function App(props) {
  initiliseGoogleAnalytics();
  pageView();

  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response && error.response.status === 500) {
        props.serverError();
        if (props.location.pathname !== `/error500`) {
          props.history.push(`/error500`);
        }
      }
      if (error.response && error.response.status === 401) {
        // if (axios.defaults.headers.common.Authtoken) {
        if (props.history.location.pathname !== '/login') {
          props.userLogout(props.history);
        }
        // } else {
        //   if (props.location.pathName !== '/login') {
        //     props.history.push(`/login`);
        //   }
        // }
      }
      if (error.response && error.response.status === 300) {
        if (props.history.location.pathname !== '/twostepauth') {
          localStorage.setItem('authToken', error.response.data.data.authToken);
          setAuthToken(error.response.data.data.authToken);
          props.history.push('/twostepauth');
        }
      }
      if (error.response && error.response.status === 409) {
        if (props.history.location.pathname !== '/resetpassword') {
          props.history.push(`/resetpassword`);
        }
      }
      if (error.response && error.response.status === 403) {
        if (
          props.history.location.pathname !==
          `/passwordexpiry/${error.response.data.data.resetPasswordToken}`
        ) {
          props.history.push(
            `/passwordexpiry/${error.response.data.data.resetPasswordToken}`
          );
        }
      }
      return Promise.reject(error);
    }
  );
  return <Routes />;
}

export default connect(null, { serverError, userLogout })(withRouter(App));
